import * as React from "react";
import Empty from "../Empty";
import { ConfigConsumer } from "./ConfigProvider";
import { jsx as _jsx } from "react/jsx-runtime";
var renderEmpty = function renderEmpty(componentName) {
  return /*#__PURE__*/_jsx(ConfigConsumer, {
    children: function children(_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var prefix = getPrefixCls("empty");
      switch (componentName) {
        case "Table":
        case "List":
          return /*#__PURE__*/_jsx(Empty, {
            image: Empty.PRESENTED_IMAGE_SIMPLE
          });
        case "Select":
        case "TreeSelect":
        case "Cascader":
        case "Transfer":
        case "Mentions":
          return /*#__PURE__*/_jsx(Empty, {
            image: Empty.PRESENTED_IMAGE_SIMPLE,
            className: "".concat(prefix, "-small")
          });
        default:
          return /*#__PURE__*/_jsx(Empty, {});
      }
    }
  });
};
export default renderEmpty;